module.exports = __webpack_public_path__ + "static/media/me_medium.477681bf.jpg";